import {FC} from 'react'
import DOMPurify from 'dompurify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCircleInfo} from '@fortawesome/free-solid-svg-icons'
import {PlatformDataType, RetrievePlatformDataType} from 'src/interfaces/Platform.interface'
import {applyPlatformSettingShortcodes} from 'src/utils/platformSettingDisplayText'
type SettingNotesProps = {
  notes?: string | null
  retrivedPlatformData?: RetrievePlatformDataType | null
  mainStoreData?: PlatformDataType | null
  pricingEnabledFrom?: string
  className?: string
}

export const getSanitizedSettingNotesHtml = ({
  notes,
  retrivedPlatformData,
  mainStoreData,
  pricingEnabledFrom = '',
}: SettingNotesProps): string => {
  if (!notes?.trim()) return ''

  return DOMPurify.sanitize(
    applyPlatformSettingShortcodes(notes, {
      retrievedPlatform: retrivedPlatformData,
      mainStore: mainStoreData,
      sourceChannelName: pricingEnabledFrom,
    })
  )
}

const SettingNotes: FC<SettingNotesProps> = ({
  notes,
  retrivedPlatformData,
  mainStoreData,
  pricingEnabledFrom,
  className = 'p-1 d-flex ms-2 mt-2',
}) => {
  const sanitizedHtml = getSanitizedSettingNotesHtml({
    notes,
    retrivedPlatformData,
    mainStoreData,
    pricingEnabledFrom,
  })

  if (!sanitizedHtml) return null

  return (
    <span className={className} style={{color: 'darkgrey'}}>
      <span style={{margin: '1px 4px', color: 'darkgrey'}}>
        <FontAwesomeIcon icon={faCircleInfo} />
      </span>
      <div dangerouslySetInnerHTML={{__html: sanitizedHtml}} />
    </span>
  )
}

export default SettingNotes
